import { createFeatureSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import {
  entityReducerMap,
  IEntityList,
  IEntityState,
  IFilteredLists,
  initialListState,
} from '../entity-data/entity-data.reducer';
import { EntityTypesEnum } from '../../app.enum';
import { DEFAULT_SEARCH_PARAMS } from './item-data.data';

// feature name
export const FEATURE_NAME = 'item-data';

// state interface
export interface IState extends IEntityState {}

export const intialItemListState: IEntityList = {
  ...initialListState,
  searchParams: DEFAULT_SEARCH_PARAMS,
};

// initial state of store
export const initialFilteredListsState: IFilteredLists = {
  all: intialItemListState,
  parts: intialItemListState,
  labor: intialItemListState,
  search: intialItemListState,
};

export const initialState: IState = {
  filteredLists: initialFilteredListsState,
  editingEntity: null,
  selectedEntities: null,
  masterError: null,
  dispatchedResponse: null,
};

// reducers
const reducerFn = handleActions(
  {
    ...entityReducerMap<IState>(),
  } as any,
  initialState
);

// filter actions by entityType
export function reducer(state: IState = initialState, action: any) {
  return action.payload && action.payload.entityType === EntityTypesEnum.product
    ? reducerFn(state, action)
    : state;
}

// selectors
export const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);
